import React from 'react';
import styled from "styled-components";
import {getCssSizeValue} from "@/utils/utils";
import {BREAKPOINTS} from "@/styles/themeSettings";

const Wrapper = styled.div`
	color: ${({theme}) => theme.colors.richBlack};

	h2 {
		margin-top: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
		margin-bottom: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
		@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
			margin-top: ${getCssSizeValue(64, BREAKPOINTS.TABLET)};
			margin-bottom: ${getCssSizeValue(20, BREAKPOINTS.TABLET)};
		}
		@media (min-width: ${({theme}) => theme.breakpoints.desktop}px) {
			margin-top: ${getCssSizeValue(96, BREAKPOINTS.DESKTOP)};
			margin-bottom: ${getCssSizeValue(96, BREAKPOINTS.DESKTOP)};
		}
	}
	
	h3, h4, h5, h6 {
        margin-top: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
        margin-bottom: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
		@media (min-width: ${({theme}) => theme.breakpoints.desktop}px) {
            margin-top: ${getCssSizeValue(48, BREAKPOINTS.DESKTOP)};
			margin-bottom: ${getCssSizeValue(24, BREAKPOINTS.DESKTOP)};
		}
	}
	
	a {
		color: ${({theme}) => theme.colors.pennRed} !important;
	}
	
	div.full-width-padding-left {
		width: 100vw;
		//margin-left: calc(-1 * (100vw - ))
	}
	
	&.align-end {
		text-align: end;
	}
	
	&.italic {
		font-style: italic;
	}
`
const TextWrapper = ({ children, ...props }) => {
	return (
		<Wrapper {...props} >
			{children}
		</Wrapper>
	);
};

export default TextWrapper;
